export default {
  errorNameTh: null,
  errorNameEn: null,
  errorDetailTh: null,
  errorDetailEn: null,
  errorStatus: null,
  errorStartDate: null,
  errorEndDate: null,
  errorBrandCode: null,
  errorStoreCodes: null,
  errorFormType: null,
};
